import React from "react";
import { Page, Layout, Card, Banner, TextContainer, Icon, List, TextField, Button, TextStyle, } from "@shopify/polaris";
import { DuplicateMinor } from "@shopify/polaris-icons";
import Env from "../Env";
import LegalAppBridge from "../LegalAppBridge";
import { CsI18n } from "../shared/csI18n/csI18n";

const Support = () => {
  const handleCopyEmail = () => {
    const email = document.getElementById('support_email');
    email.select();
    document.execCommand('copy');
    LegalAppBridge.toast('Copied to clipboard!');
  }

  return (
    <Page>
      <Layout>
        <Layout.Section>
          <Card>
            <Banner title={CsI18n.t('Support request')} status='info'>
              <TextContainer>
                <p>
                  <CsI18n>Technical support is available by e-mail via our helpdesk.</CsI18n>
                  <br />
                  <CsI18n>Please provide us</CsI18n>:
                </p>

                <List type='bullet'>
                  <List.Item><CsI18n>A relevant description of the trouble</CsI18n></List.Item>
                  <List.Item><CsI18n>Your name</CsI18n></List.Item>
                  <List.Item>
                    <CsI18n>Your store URL</CsI18n>: <TextStyle variation="positive">{Env.getStoreName()}</TextStyle>
                  </List.Item>
                  <List.Item><CsI18n>Screenshot if applicable</CsI18n></List.Item>
                </List>

                <TextField
                  label={CsI18n.t('Support email')}
                  type="email"
                  id="support_email"
                  value="support.legal-app@common-services.com"
                  readOnly
                  connectedRight={
                    <Button onClick={handleCopyEmail}>
                      <Icon source={DuplicateMinor} />
                    </Button>
                  }
                />
              </TextContainer>
            </Banner>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
};

export default Support;
